export default {
  '--checkbox-unchecked-color': '#fff'
};